export const MEDICAL_TREATING_REPORT_TYPE = {
  both: 'both',
  medications: 'medications',
  mts: 'mts'
}
